import { render } from "./PartialPayments.vue?vue&type=template&id=40c017ae&scoped=true"
import script from "./PartialPayments.vue?vue&type=script&lang=js"
export * from "./PartialPayments.vue?vue&type=script&lang=js"

import "./PartialPayments.vue?vue&type=style&index=0&id=40c017ae&scoped=true&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c017ae"]])

export default __exports__